import { Routes } from '@angular/router';
import { OverviewProjects } from './features/projects/overview-projects/overview-projects';
import { ProjectDetails } from './features/projects/project-details/project-details';
import { PendingChecks } from './features/checks/pending-checks/pending-checks';
import { AllChecks } from './features/checks/all-checks/all-checks';
import { authGuard } from './core/common/auth/auth-guard';
import { AuthRedirectComponent } from './core/common/auth/auth-redirect';

const appBase: string = 'qs';

export const routes: Routes = [
    // Kein Guard – MSAL verarbeitet hier den Redirect-Callback von Microsoft
    { path: 'auth', component: AuthRedirectComponent },
    { path: '', redirectTo: appBase + '/projects', pathMatch: 'full' },
    { path: appBase + '/projects', component: OverviewProjects, canActivate: [authGuard] },
    { path: appBase + '/checks', component: AllChecks, canActivate: [authGuard] },
    { path: appBase + '/project/:projectCode', component: ProjectDetails, canActivate: [authGuard] },
    { path: appBase + '/project/:projectCode/check/:id', component: PendingChecks, canActivate: [authGuard] },
    { path: '**', redirectTo: appBase + '/projects' },
];
